<template>
  <ModalDefault modal_id="vcardModal"
                header="y"
                size="modal-lg modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_1086')"
                :footer="chat.new_vcard.name.length > 2 && chat.new_vcard.phone.length > 10"
                icon="bx bx-id-card mr-1">
    <div class="px-2 py-2 pb-3" slot="body">
      <div>
        <div class="animated--grow-in d-flex">
          <div class="cursor-default w-100"  style="align-items: center; align-self: center;">
            <div class="row pb-2">
              <div class="col-md-12 mt-2 pt-2 pb-0 px-3">
                <div role="alert" class="alert alert-info rounded-0 alert-dismissible">
                  <small class="d-block">
                    {{ getTranslations('expression_1084') }} {{ configs.data.partner.name }}, {{ getTranslations('expression_1085') }}
                  </small>
                  <button type="button" data-dismiss="alert" aria-label="Close" class="close">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
              </div>
              <div class="col-md-6 pt-2 pb-0 px-3">
                <label class="mt-0 mb-1">{{ getTranslations('expression_42') }}</label>
                <div class="input-group mb-3 mt-0">
                  <input type="text"
                         v-model="chat.new_vcard.name"
                         class="input_forms form-control">
                </div>
              </div>
              <div class="col-md-6 pt-2 pb-0 px-3">
                <label class="mt-0 mb-1">{{ getTranslations('expression_54') }}</label>
                <div class="input-group mb-3 mt-0">
                  <input type="number"
                         v-model="chat.new_vcard.phone"
                         class="input_forms form-control">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div v-if="!sending_message" @click.prevent="sendVcard" class="d-flex justify-center align-items-center shadow-sm cursor_pointer animated--grow-in btn-primary py-2 px-3">
        <i class="animated--grow-in bx bxs-send hover_icons"></i>
        <span class="text-white ml-2">{{ getTranslations('expression_562') }}</span>
      </div>

      <div v-else class="d-flex justify-center align-items-center shadow-sm cursor_pointer animated--grow-in btn-primary py-2 px-3">
        <v-progress-circular :width="3" :size="20" indeterminate color="primary"></v-progress-circular>
        <span class="text-white ml-2">{{ getTranslations('expression_36') }}</span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";
import $ from "jquery";
import {mapGetters, mapState} from "vuex";

export default {
  name: "ModalChatVcard",
  components: {
    ModalDefault,
  },
  data() {
    return {
      sending_message: false
    }
  },
  computed: {
    ...mapState(['chat', 'me', 'operators', 'configs']),
    ...mapGetters([
      'getDepartmentsArray',
      'getLeadObject',
      'getUserObject',
      'getChannelObject',
      'getDepartmentObject',
      'getOperatorsArray',
      'getOperatorObject',
      'getInterestsArray',
      'getMotivesArray'
    ])
  },
  methods: {
    isOperator(department_id) {
      if (department_id === null) {
        department_id = this.getChannelObject('id', this.chat.ticket.channel_id).parameter.department_id
      }
      let operator = this.operators.data.find(operator => {
        return operator.department_id === department_id && operator.user_id === this.me.data.id;
      });
      if (operator !== undefined) {
        return operator.id
      } else {
        return null
      }
    },
    sendVcard(){
      this.sending_message = true
      const format = {
        name: this.chat.new_vcard.name,
        phone: this.chat.new_vcard.phone
      }
      this.chat.ui.row_textarea = 1
      this.chat.new_vcard.channel_id = this.chat.ticket.channel_id
      this.chat.new_vcard.ticket_id = this.chat.ticket.id
      this.chat.new_vcard.text = `vcard|${JSON.stringify(format)}`
      this.chat.new_vcard.operator_id = this.isOperator(this.chat.ticket.department_id)
      this.chat.new_vcard.department_id = this.chat.ticket.department_id
      this.$store.dispatch('sendMessage', this.chat.new_vcard)
      this.chat.new_vcard = {
        name: "",
        phone: "",
      }
      this.chat.isShowEmoji = false;

      setTimeout(() => {
        $('#vcardModal').modal('hide')
        this.sending_message = false
      }, 500)
    },
  }
}
</script>

<style scoped>

</style>
